import TrackMap from "../controllers/TrackMap";
import ToastNotification from "../utils/ToastNotification";
import ConfirmationModal from "../../common/ConfirmationModal";
import "chartjs-plugin-annotation";
import "moment-timezone";

export default class TrackDetail {

	MILE_IN_KILOMETER = 1.60934;
	NAUTIC_MILE_IN_KILOMETER = 1.852;
	METER_IN_FEET = 3.28084;
	currentGraphType = 'heart-rate';
	chartLabels = {};
	constructor() {

		this.data = null;
		this.points_header = null;
		this.points_header_withData = [];
		this.points = [];
		this.originalPoints = null; // Store original full track for crop reset
		this.chart = null;
		this.hover_time = null;
		this.selected_time = null;
		this.mapHandler = null;
		this.step = 0;
		this.current_index = 1;
		this.current_points = [];
		this.position_tooltip_pointer = "left";
		this.user_unit_system = "measure_metric";
		this.ignore_altitude = false;

		this.distanceConversion = 1;
		this.speedConversion = 1;

		// Track crop feature
		this.cropStartPercent = 0;
		this.cropEndPercent = 100;
		this.cropStartIndex = 0;
		this.cropEndIndex = null;
		this.modalInitialized = false;
		this.chartDragActive = false;
		this.chartDragBoundary = null; // 'start' or 'end'
		this.chartDragThreshold = 15; // pixels threshold for boundary detection
		this.isCropped = false; // Track if we've applied a crop
		this.confirmationModal = new ConfirmationModal(); // Modal for confirmations

		this.bindEvents();
	}

	bindEvents() {
		var self = this;
		let clickDisabled = false;

		$('.card .collapse').on('click', function() {
			clickDisabled = true;
		
			setTimeout(function() {
				clickDisabled = false;
			}, 3000);
		});

		$('[data-toggle="collapse"]').on('mouseenter', function() {
			if (!clickDisabled) {
				$(this).parents('.card').find('.collapse').collapse('show');
			}
		});

		$("#show_3d").unbind("click").click(function () {
			window.location.href = window.location.href + "?mode=3D";
		});

		$(".img-to-graph").unbind("click").click(function (e) {
			e.preventDefault();
			$('html, body').animate({ scrollTop: 0 }, 1200, 'easeInOutCubic');
			window.location.hash = 'graph-map';
		});

		$(".graph-to-img").unbind("click").click(function (e) {
			e.preventDefault();
			$('html,body').animate({scrollTop: $("a[name='images_listing']").offset().top}, 1200, 'easeInOutCubic');
			window.location.hash = 'images_listing';
		});

		$("#clear-graph-selection-btn").unbind("click").click(function (e) {
			e.preventDefault();
			self.resetCrop();
		});

		$(".peak-speed-btn").unbind("click").click(function (e) {
			e.preventDefault();
			this.current_points = self.points.slice($(this).data("pointStart"), $(this).data("pointEnd"));
			self.mapHandler.updatePoints(this.current_points);
			self.displayGraph(this.current_points, $(this).data("title"), null, true);
		});

		$(".performance-btn").unbind("click").click(function (e) {
			e.preventDefault();
			this.current_points = self.points.slice($(this).data("pointStart"), $(this).data("pointEnd"));
			self.mapHandler.updatePoints(this.current_points);
			self.displayGraph(this.current_points, $(this).data("title"), null, true);
		});

		$(".split-btn").unbind("click").click(function (e) {
			e.preventDefault();
			this.current_points = self.points.slice($(this).data("pointStart"), $(this).data("pointEnd"));
			self.mapHandler.updatePoints(this.current_points);
			self.displayGraph(this.current_points, $(this).data("title"), null, true);
		});

		$(".graph_switcher").unbind("click").click(function (e) {
			e.preventDefault();
			$(this).blur(); // Remove focus to avoid darkening effect
			if (!self.chart || !self.chart.data) {
				return;
			}
			const type = $(this).data("graph-type");
			if (type != self.currentGraphType) {
				self.currentGraphType = type;
				const points = self.data.points;
				self.displayGraph(points, null, null, false);
				$('.graph_switcher.btn-warning').removeClass('btn-warning').addClass('btn-light');
				$(this).removeClass('btn-light').addClass('btn-warning');
			}
		});

		var trackGraph = document.getElementById("track-graph");

		if (trackGraph != null) {
			trackGraph.onclick = function (evt) {
				self.selected_time = self.hover_time;
				self.chart.options.annotation.annotations[0].value = self.selected_time;
				self.chart.update();
			
				let index = parseInt(self.step * self.current_index);
				$("#replay-position").val(index);

				self.mapHandler.onChartClick(index);
			};
		}

		window.application.setOnDataChangeListener(this);
	}

	initializeCropModal() {
		const self = this;

		const toggleBtn = document.getElementById('track-crop-toggle-btn');
		const modal = document.getElementById('track-crop-modal');
		const closeBtn = document.getElementById('track-crop-modal-close');
		const startSlider = document.getElementById('track-crop-start-slider');
		const endSlider = document.getElementById('track-crop-end-slider');
		const applyBtn = document.getElementById('track-crop-apply-btn');
		const resetBtn = document.getElementById('track-crop-reset-btn');
		const saveNewBtn = document.getElementById('track-crop-save-new-btn');

		if (!modal || !toggleBtn) {
			console.warn('Crop modal elements not found');
			return;
		}

		// Toggle modal visibility
		toggleBtn.addEventListener('click', function(e) {
			e.preventDefault();
			const isOpening = !modal.classList.contains('active');

			if (isOpening) {
				modal.classList.add('active');
				// Show modal without animation
				$(modal).css({ display: 'block', top: '80px', opacity: 1 });
				// When opening modal, keep map showing current state, but show original in chart for adjustment
				if (self.originalPoints) {
					// Reset map state to ensure we're showing the normal red path
					// (not green subPath from previous peak speed selections)
					if (self.mapHandler) {
						self.mapHandler.isSubPath = false;
						self.mapHandler.subPoints = [];

						// Only redraw if there was a previous subPath state (to clear green path)
						// Do NOT restore original points to map - keep showing cropped state
						const needsRedraw = self.mapHandler.subPath !== null;
						if (needsRedraw) {
							self.mapHandler.redrawPath();
						}
					}

					// Display original full track in chart for adjustment
					self.displayGraph(self.originalPoints, null, null, false);

					// Reset sliders to show full range (0-100) when reopening
					// This way user can make a fresh crop selection
					if (!self.isCropped) {
						self.cropStartPercent = 0;
						self.cropEndPercent = 100;
						const startSlider = document.getElementById('track-crop-start-slider');
						const endSlider = document.getElementById('track-crop-end-slider');
						if (startSlider) startSlider.value = 0;
						if (endSlider) endSlider.value = 100;
						self.updateSliderRange();
					}

					// Show overlays based on current crop percentages
					self.showCropOverlays();

					// Update "Save to New Track" button visibility
					self.updateSaveNewTrackButtonVisibility();
				}
			} else {
				self.closeCropModal();
			}
		});

		// Close modal
		closeBtn.addEventListener('click', function() {
			self.closeCropModal();
		});

		// Initialize sliders
		if (startSlider && endSlider) {
			startSlider.addEventListener('input', function() {
				self.lastMovedSlider = 'start';
				self.onSliderChange();
			});

			endSlider.addEventListener('input', function() {
				self.lastMovedSlider = 'end';
				self.onSliderChange();
			});
		}

		// Apply crop button
		if (applyBtn) {
			applyBtn.addEventListener('click', function() {
				self.applyCropFromSliders();
			});
		}

		// Reset button
		if (resetBtn) {
			resetBtn.addEventListener('click', function() {
				self.resetCrop();
			});
		}

		// Save to new track button
		if (saveNewBtn) {
			saveNewBtn.addEventListener('click', function() {
				self.saveToNewTrack();
			});
		}

		this.modalInitialized = true;

		// Bind chart interactions
		this.bindChartCropInteractions();
	}

	closeCropModal() {
		const self = this;
		const modal = document.getElementById('track-crop-modal');
		if (!modal) return;

		// Animate modal closing with jQuery - slide down
		$(modal).animate({
			top: '120px',
			opacity: 0
		}, 300, 'swing', function() {
			// After animation completes, reset position and hide
			$(modal).css({ display: 'none', top: '80px' });
			modal.classList.remove('active');

			// Hide overlays
			self.hideCropOverlays();

			// Restore the chart to the current points (might be cropped)
			if (self.points) {
				self.displayGraph(self.points, null, null, false);

				// Restore map to cropped state if needed
				if (self.isCropped && self.mapHandler) {
					self.mapHandler.points = self.points;
					self.mapHandler.currentPosition = self.points.length - 1;
					self.mapHandler.isSubPath = false;
					self.mapHandler.redrawPath();
				}
			}
		});
	}

	bindChartCropInteractions() {
		const self = this;
		const canvas = document.getElementById('track-graph');
		if (!canvas) return;

		canvas.addEventListener('mousemove', function(e) {
			self.onChartMouseMove(e);
		});

		canvas.addEventListener('mousedown', function(e) {
			self.onChartMouseDown(e);
		});

		canvas.addEventListener('mouseup', function(e) {
			self.onChartMouseUp(e);
		});

		canvas.addEventListener('mouseleave', function(e) {
			self.onChartMouseLeave(e);
		});
	}

	onChartMouseMove(e) {
		const canvas = e.target;
		const modal = document.getElementById('track-crop-modal');

		// Only enable interactions when modal is open
		if (!modal || !modal.classList.contains('active')) {
			canvas.style.cursor = '';
			return;
		}

		const rect = canvas.getBoundingClientRect();
		const x = e.clientX - rect.left;
		const chartWidth = rect.width;

		// Calculate boundary positions in pixels
		const startBoundaryX = (this.cropStartPercent / 100) * chartWidth;
		const endBoundaryX = (this.cropEndPercent / 100) * chartWidth;

		// Check if mouse is near boundaries
		const nearStart = Math.abs(x - startBoundaryX) < this.chartDragThreshold;
		const nearEnd = Math.abs(x - endBoundaryX) < this.chartDragThreshold;

		// If dragging, update the boundary position
		if (this.chartDragActive && this.chartDragBoundary) {
			const newPercent = Math.max(0, Math.min(100, (x / chartWidth) * 100));

			if (this.chartDragBoundary === 'start') {
				// Don't allow start to go past end
				if (newPercent < this.cropEndPercent - 1) {
					this.cropStartPercent = newPercent;
					this.updateSliderFromChart();
					this.updateOverlaysFromPercent();
					this.updateSliderRange();
					this.updateMapWithCroppedData(); // Update map in real-time
				}
			} else if (this.chartDragBoundary === 'end') {
				// Don't allow end to go before start
				if (newPercent > this.cropStartPercent + 1) {
					this.cropEndPercent = newPercent;
					this.updateSliderFromChart();
					this.updateOverlaysFromPercent();
					this.updateSliderRange();
					this.updateMapWithCroppedData(); // Update map in real-time
				}
			}
			canvas.style.cursor = 'col-resize';
		} else {
			// Show appropriate cursor when hovering near boundaries
			if (nearStart || nearEnd) {
				canvas.style.cursor = 'col-resize';
			} else {
				canvas.style.cursor = '';
			}
		}
	}

	onChartMouseDown(e) {
		const canvas = e.target;
		const modal = document.getElementById('track-crop-modal');

		// Only enable interactions when modal is open
		if (!modal || !modal.classList.contains('active')) return;

		const rect = canvas.getBoundingClientRect();
		const x = e.clientX - rect.left;
		const chartWidth = rect.width;

		// Calculate boundary positions in pixels
		const startBoundaryX = (this.cropStartPercent / 100) * chartWidth;
		const endBoundaryX = (this.cropEndPercent / 100) * chartWidth;

		// Check if mouse is near boundaries
		const nearStart = Math.abs(x - startBoundaryX) < this.chartDragThreshold;
		const nearEnd = Math.abs(x - endBoundaryX) < this.chartDragThreshold;

		if (nearStart) {
			this.chartDragActive = true;
			this.chartDragBoundary = 'start';
			e.preventDefault();
		} else if (nearEnd) {
			this.chartDragActive = true;
			this.chartDragBoundary = 'end';
			e.preventDefault();
		}
	}

	onChartMouseUp(e) {
		if (this.chartDragActive) {
			this.chartDragActive = false;
			this.chartDragBoundary = null;
			// Map is already updated in real-time during drag
			// No need to call applyCropFromSliders here
		}
	}

	onChartMouseLeave(e) {
		if (this.chartDragActive) {
			this.chartDragActive = false;
			this.chartDragBoundary = null;
		}
		e.target.style.cursor = '';
	}

	updateSliderFromChart() {
		const startSlider = document.getElementById('track-crop-start-slider');
		const endSlider = document.getElementById('track-crop-end-slider');

		if (startSlider && endSlider) {
			startSlider.value = Math.round(this.cropStartPercent);
			endSlider.value = Math.round(this.cropEndPercent);

			// Update value displays
			document.getElementById('crop-start-value').textContent = Math.round(this.cropStartPercent);
			document.getElementById('crop-end-value').textContent = Math.round(this.cropEndPercent);
		}
	}

	onSliderChange() {
		const startSlider = document.getElementById('track-crop-start-slider');
		const endSlider = document.getElementById('track-crop-end-slider');

		if (!startSlider || !endSlider) return;

		let startValue = parseInt(startSlider.value);
		let endValue = parseInt(endSlider.value);

		// Ensure start is always less than end
		if (startValue >= endValue) {
			if (this.lastMovedSlider === 'start') {
				endValue = Math.min(100, startValue + 1);
				endSlider.value = endValue;
			} else {
				startValue = Math.max(0, endValue - 1);
				startSlider.value = startValue;
			}
		}

		this.cropStartPercent = startValue;
		this.cropEndPercent = endValue;

		// Update visual slider range
		this.updateSliderRange();

		// Update value displays
		document.getElementById('crop-start-value').textContent = startValue;
		document.getElementById('crop-end-value').textContent = endValue;

		// Update overlays on chart
		this.updateOverlaysFromPercent();

		// Update map in real-time with cropped data
		this.updateMapWithCroppedData();

		// Show/hide "Save to New Track" button based on crop state
		this.updateSaveNewTrackButtonVisibility();
	}

	updateMapWithCroppedData() {
		if (!this.originalPoints || this.originalPoints.length === 0) {
			return;
		}

		// Calculate indices from current percentages based on ORIGINAL points
		const startIndex = Math.floor((this.cropStartPercent / 100) * this.originalPoints.length);
		const endIndex = Math.ceil((this.cropEndPercent / 100) * this.originalPoints.length);

		// Get cropped points for the map
		const croppedPoints = this.originalPoints.slice(startIndex, endIndex);

		// Preview crop on map WITHOUT showing as subPath (no green/arrows)
		if (this.mapHandler && croppedPoints.length > 0) {
			this.previewCropOnMap(croppedPoints);
		}
	}

	previewCropOnMap(croppedPoints) {
		// Temporarily replace map points for crop preview
		// This avoids the green subPath styling from updatePoints()
		if (!this.mapHandler) return;

		// Store original map state if this is the first preview
		if (!this.originalMapPoints) {
			this.originalMapPoints = this.mapHandler.points;
		}

		// Replace points directly and redraw (not as subPath)
		this.mapHandler.points = croppedPoints;
		this.mapHandler.currentPosition = croppedPoints.length - 1;
		this.mapHandler.isSubPath = false; // Important: Keep as main path
		this.mapHandler.redrawPath();

		// Update marker position
		if (croppedPoints.length > 0) {
			const point = croppedPoints[croppedPoints.length - 1];
			this.mapHandler.marker.setLatLng([point.latitude, point.longitude]);
			this.mapHandler.setMarkerSize(point.altitude);
		}
	}

	updateSliderRange() {
		const rangeElement = document.getElementById('track-crop-slider-range');
		if (!rangeElement) return;

		const left = this.cropStartPercent;
		const right = 100 - this.cropEndPercent;

		rangeElement.style.left = left + '%';
		rangeElement.style.right = right + '%';
	}

	updateOverlaysFromPercent() {
		const overlayStart = document.getElementById('track-crop-overlay-start');
		const overlayEnd = document.getElementById('track-crop-overlay-end');

		if (!overlayStart || !overlayEnd || !this.chart) {
			return;
		}

		// Get the actual chart area from Chart.js
		const chartArea = this.chart.chartArea;
		if (!chartArea) {
			return;
		}

		// Get canvas element and its position
		const canvas = this.chart.canvas;
		const canvasRect = canvas.getBoundingClientRect();
		const parentRect = overlayStart.parentElement.getBoundingClientRect();

		// Calculate the offset between parent and canvas (canvas has margin-left: -10px)
		const canvasOffsetLeft = canvasRect.left - parentRect.left;
		const canvasOffsetTop = canvasRect.top - parentRect.top;

		// Calculate chart dimensions from actual rendered area, accounting for canvas offset
		const leftMargin = canvasOffsetLeft + chartArea.left;
		const rightMargin = (parentRect.right - canvasRect.right) + (canvas.offsetWidth - chartArea.right);
		const chartWidth = chartArea.right - chartArea.left;
		const chartHeight = chartArea.bottom - chartArea.top;
		const topPosition = canvasOffsetTop + chartArea.top;

		// Calculate overlay widths from percentages (based on actual chart area)
		const startWidth = (this.cropStartPercent / 100) * chartWidth;
		const endWidth = ((100 - this.cropEndPercent) / 100) * chartWidth;

		// Update start overlay - positioned from left edge of chart area
		overlayStart.style.left = leftMargin + 'px';
		overlayStart.style.width = startWidth + 'px';
		overlayStart.style.top = topPosition + 'px';
		overlayStart.style.height = chartHeight + 'px';

		// Update end overlay - positioned from right edge of chart area
		overlayEnd.style.right = rightMargin + 'px';
		overlayEnd.style.width = endWidth + 'px';
		overlayEnd.style.top = topPosition + 'px';
		overlayEnd.style.height = chartHeight + 'px';
	}

	applyCropFromSliders() {
		if (!this.originalPoints || this.originalPoints.length === 0) {
			return;
		}

		// Calculate indices from percentages based on ORIGINAL points
		this.cropStartIndex = Math.floor((this.cropStartPercent / 100) * this.originalPoints.length);
		this.cropEndIndex = Math.ceil((this.cropEndPercent / 100) * this.originalPoints.length);

		// Ensure valid range
		this.cropStartIndex = Math.max(0, this.cropStartIndex);
		this.cropEndIndex = Math.min(this.originalPoints.length, this.cropEndIndex);

		if (this.cropEndIndex <= this.cropStartIndex) {
			this.cropEndIndex = this.cropStartIndex + 1;
		}

		// Get cropped points
		const croppedPoints = this.originalPoints.slice(this.cropStartIndex, this.cropEndIndex);

		console.log('Applying crop:', {
			startPercent: this.cropStartPercent,
			endPercent: this.cropEndPercent,
			startIndex: this.cropStartIndex,
			endIndex: this.cropEndIndex,
			totalOriginalPoints: this.originalPoints.length,
			croppedCount: croppedPoints.length
		});

		// IMPORTANT: Make cropped points the new "full track"
		// This prevents the map from showing it as a selection (green/red)
		this.points = croppedPoints;
		this.current_points = croppedPoints;
		this.isCropped = true;

		// Hide the grey overlays - chart will now show only cropped data
		this.hideCropOverlays();

		// Rebuild the chart with ONLY the cropped data (no overlays)
		this.displayGraph(croppedPoints, null, null, false);

		// Update the map - directly set as main path (NOT as subPath to avoid green coloring)
		if (this.mapHandler) {
			this.mapHandler.points = croppedPoints;
			this.mapHandler.currentPosition = croppedPoints.length - 1;
			this.mapHandler.isSubPath = false; // Keep as main red path
			this.mapHandler.subPoints = []; // Clear any subPath data
			this.mapHandler.redrawPath();

			// Update marker position
			if (croppedPoints.length > 0) {
				const point = croppedPoints[croppedPoints.length - 1];
				this.mapHandler.marker.setLatLng([point.latitude, point.longitude]);
				this.mapHandler.setMarkerSize(point.altitude);
			}
		}

		// Close the modal after applying with smooth transition
		this.closeCropModal();

		console.log('Crop applied - cropped data is now the "full track", no highlighting');
	}

	showCropOverlays() {
		const overlayStart = document.getElementById('track-crop-overlay-start');
		const overlayEnd = document.getElementById('track-crop-overlay-end');

		// Initialize modal if not done
		if (!this.modalInitialized) {
			this.initializeCropModal();
		}

		if (overlayStart && overlayEnd) {
			overlayStart.classList.add('active');
			overlayEnd.classList.add('active');
			this.updateOverlaysFromPercent();
		}
	}

	hideCropOverlays() {
		const overlayStart = document.getElementById('track-crop-overlay-start');
		const overlayEnd = document.getElementById('track-crop-overlay-end');

		if (overlayStart && overlayEnd) {
			overlayStart.classList.remove('active');
			overlayEnd.classList.remove('active');
		}
	}

	resetCrop() {
		// Reset crop state
		this.cropStartPercent = 0;
		this.cropEndPercent = 100;
		this.cropStartIndex = 0;
		this.cropEndIndex = this.originalPoints ? this.originalPoints.length : 0;
		this.isCropped = false;

		// Reset sliders
		const startSlider = document.getElementById('track-crop-start-slider');
		const endSlider = document.getElementById('track-crop-end-slider');

		if (startSlider && endSlider) {
			startSlider.value = 0;
			endSlider.value = 100;
		}

		// Update displays
		const startValueEl = document.getElementById('crop-start-value');
		const endValueEl = document.getElementById('crop-end-value');
		if (startValueEl) startValueEl.textContent = '0';
		if (endValueEl) endValueEl.textContent = '100';

		// Update slider range visual
		this.updateSliderRange();

		// Hide overlays
		this.hideCropOverlays();

		// Restore ORIGINAL full track data
		if (this.originalPoints) {
			// IMPORTANT: Restore originalPoints as the full track
			this.points = this.originalPoints;
			this.current_points = this.originalPoints;

			// Rebuild chart with full data (no title)
			this.displayGraph(this.originalPoints, null, null, false);

			// Reset map to show full track - directly set as main path (NOT subPath)
			if (this.mapHandler) {
				this.mapHandler.points = this.originalPoints;
				this.mapHandler.currentPosition = this.originalPoints.length - 1;
				this.mapHandler.isSubPath = false; // Keep as main red path
				this.mapHandler.subPoints = []; // Clear any subPath data
				this.mapHandler.redrawPath();

				// Update marker position
				if (this.originalPoints.length > 0) {
					const point = this.originalPoints[this.originalPoints.length - 1];
					this.mapHandler.marker.setLatLng([point.latitude, point.longitude]);
					this.mapHandler.setMarkerSize(point.altitude);
				}
			}
		}

		// Close the modal with smooth transition
		this.closeCropModal();

		// Hide the "Save to New Track" button since crop is reset
		this.updateSaveNewTrackButtonVisibility();

		console.log('Crop reset - original full track restored');
	}

	updateSaveNewTrackButtonVisibility() {
		const saveNewBtn = document.getElementById('track-crop-save-new-btn');
		if (!saveNewBtn) return;

		// Show button only if crop has been modified from default (0-100%)
		const isCropModified = this.cropStartPercent !== 0 || this.cropEndPercent !== 100;

		if (isCropModified) {
			saveNewBtn.classList.remove('d-none');
		} else {
			saveNewBtn.classList.add('d-none');
		}
	}

	saveToNewTrack() {
		const self = this;

		// Show confirmation modal
		this.confirmationModal.displayConfirm(
			I18n.t('website.track.chart.save_to_new_track'),
			I18n.t('website.track.chart.save_to_new_track_confirm'),
			{
				positive_btn: {
					type: "success",
					label: I18n.t('website.track.chart.save_to_new_track_confirm_action'),
					callback: function() {
						self.performSaveToNewTrack();
					}
				},
				negative_btn: {
					label: I18n.t('website.track.chart.save_to_new_track_cancel')
				}
			}
		);
	}

	performSaveToNewTrack() {
		const self = this;

		// Get the cropped time range from current crop percentages
		if (!this.originalPoints || this.originalPoints.length === 0) {
			ToastNotification.make('No track data available');
			return;
		}

		// Calculate indices from percentages
		const startIndex = Math.floor((this.cropStartPercent / 100) * this.originalPoints.length);
		const endIndex = Math.ceil((this.cropEndPercent / 100) * this.originalPoints.length);

		// Get timestamps from the cropped range
		const startTime = this.originalPoints[startIndex].date;
		const endTime = this.originalPoints[endIndex - 1].date;

		console.log('Saving new track with time range:', {
			startTime,
			endTime,
			startPercent: this.cropStartPercent,
			endPercent: this.cropEndPercent
		});

		// Make API call to duplicate track with cropped range using proper API URL
		fetch(`${window.application.getAPIUrl()}/v1/track/duplicate_track`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
				'X-STL-Token': cookies.get('STL-Token')
			},
			body: JSON.stringify({
				track_id: this.data.track.id,
				start_time: startTime,
				end_time: endTime
			})
		})
		.then(response => response.json())
		.then(data => {
			if (data.success) {
				// Close modal
				const modal = document.getElementById('track-crop-modal');
				if (modal) {
					modal.classList.remove('active');
				}

				// Show success message
				ToastNotification.postponedMessage(I18n.t("website.notifications.track_process.uploaded"));

				// Reload page to show the updated track list
				window.location.reload();
			} else {
				ToastNotification.make(data.error || 'Failed to create new track');
			}
		})
		.catch(error => {
			console.error('Error duplicating track:', error);
			ToastNotification.make('Error creating new track');
		});
	}

	updateUnitConversion() {
		this.distanceConversion = 1;
		this.speedConversion = 1;
		this.alternateDistanceConversion = 1;

		if (this.user_unit_system == "measure_imperial") {
			this.distanceConversion = 1.0 / this.MILE_IN_KILOMETER;
			this.alternateDistanceConversion = this.METER_IN_FEET;
			this.speedConversion = 1.0 / this.MILE_IN_KILOMETER;
		}
		else if (this.user_unit_system == "measure_nautic") {
			this.distanceConversion = 1.0 / this.NAUTIC_MILE_IN_KILOMETER;
			this.alternateDistanceConversion = this.METER_IN_FEET;
			this.speedConversion = 1.0 / this.NAUTIC_MILE_IN_KILOMETER;
		}
	}

	getSpeedUnit() {
		if (this.user_unit_system == "measure_imperial") {
			return "mi/h";
		}
		else if (this.user_unit_system == "measure_nautic") {
			return I18n.t("website.units.knots");
		}
		else {
			return "km/h";
		}
	}

	getDistanceUnit() {
		if (this.user_unit_system == "measure_imperial") {
			return "mi";
		}
		else if (this.user_unit_system == "measure_nautic") {
			return "nmi";
		}
		else {
			return "km";
		}
	}

	getAlternateDistanceUnit() {
		if (this.user_unit_system == "measure_imperial") {
			return "ft";
		}
		else if (this.user_unit_system == "measure_nautic") {
			return I18n.t("website.units.knots");
		}
		else {
			return "m";
		}
	}

	onDataChanged(data, isExternal = false) {
		this.data = data;
        if (!data) {
            return ;
        }
		this.mode = data.mode;
		this.ignore_altitude = data.ignore_altitude;
		this.user_unit_system = data.user_unit_system;

		this.updateUnitConversion();

		if (this.data.mode == "3D") {
			this.mapHandler = new TrackMap();
			this.mapHandler.onDataChanged(data, this, isExternal);
		}
		else {

			this.getTrack(this.data.track);
		}
	}

	onPointsReceived(points) {
		this.current_points = points;
		this.data.points = points;

		// Store original points for crop feature (only on first load)
		if (!this.originalPoints) {
			this.originalPoints = points;
		}

		if (this.data.mode == "2D") {
			this.mapHandler = new TrackMap();
			this.mapHandler.onDataChanged(data, this);
			this.checkVisibilityGraphSwitchers();
			this.setDefaultGraph();
			this.displayGraph(this.current_points, null, null, false);
		}
	}

	getTrack(track) {
		var self = this;
		if (!track || !track.user) {
			return;
		}
		var ajaxData = {
			url: window.application.getAPIUrl() + "/v1/users/" + track.user.id + "/track/" + track.id + "?type=final",
			method: "GET",
			beforeSend: function (request) {
				request.setRequestHeader("X-STL-Token", cookies.get("STL-Token"));
			},
		};

		$.ajax(ajaxData).done(function (data) {
			var json = data;
			self.points_header = json.points_header;
			self.points = self.convert_points(json.points);
			self.data.utc_offset = -(moment.unix(self.points[0].date).tz(json.time_zone).utcOffset());
			self.onPointsReceived(self.points);
		});
	}

	convert_points(points) {
		this.points_header_withData = [];
		const self = this;
		const convertedPoints = points.map((point) => {
			var convertedPoint = {};
			self.points_header.forEach((header,headerIndex) => {
				convertedPoint[header] = point[headerIndex];
				if (header == "speed" && self.user_unit_system != "measure_metric") {
					convertedPoint[header] = Math.round(point[headerIndex] * self.speedConversion * 100) / 100;
				}
				else if ((header == "altitude" || header == "elevation") && self.user_unit_system != "measure_metric") {
					convertedPoint[header] = Math.round(point[headerIndex] * self.alternateDistanceConversion);
				}

				if (point[headerIndex] && !self.points_header_withData.includes(header)) {
					self.points_header_withData.push(header);
				}
			});			
			return convertedPoint;			
		});
		return convertedPoints;
	}

	checkVisibilityGraphSwitchers() {		
		const _self = this;
		$(".graph_switcher").each((i, x) => {
			if (!$(x).hasClass('d-none')) {
				$(x).addClass('d-none');
			}
			
			const graphType = $(x).data("graph-type");
			const datasetDefinition = _self.graphDefinitions[graphType]

			if (datasetDefinition) {
				const visible = datasetDefinition.dataSets.some(x => _self.points_header_withData.includes(x.property))
				if (visible) {
					$(x).removeClass('d-none');
				}
			}
		});
	}

	setDefaultGraph() {
		const _self = this;
		$(".graph_switcher").each((i, x) => {
			const graphType = $(x).data("graph-type");
			const isHidden = $(x).hasClass('d-none');
			if (isHidden && _self.currentGraphType == graphType) {
				_self.currentGraphType = '';
			}
		});
		if (!_self.currentGraphType) {
			_self.currentGraphType = 'altitude-speed';
		}

		$(`.graph_switcher[data-graph-type='${_self.currentGraphType}']`).removeClass('btn-light').addClass('btn-warning');		
	}

	displayGraph(_points_, title, anotation_value = null, scrollTop = false) {
		if (scrollTop) {
			$('html, body').animate({ scrollTop: 0 }, 600, 'easeInOutCubic');
		}
		const self = this;

		// Check if chart canvas exists (it won't exist in mobile/application mode)
		const canvas = document.getElementById('track-graph');
		if (!canvas) {			
			return;
		}

		if (anotation_value === null) {
			anotation_value = self.selected_time || (_points_[0].date + self.data.utc_offset) * 1000;
		}
		var isSubPoint = (_points_.length < this.points.length)
		var time_step = Math.round(_points_.length / 6);

		if (_points_.length > 1000) {
			this.step = Math.round(_points_.length / 1000);
			var aux_points = [];

			for (let i = 0; i < _points_.length; i += this.step) {
				aux_points.push(_points_[i]);
			}
			_points_ = aux_points;
		} else {
			this.step = 1;
		}
		this.current_points = _points_;
		if (title != null) {
			$("#track-graph-title-container").removeClass("d-none");
		}
		else {
			$("#track-graph-title-container").addClass("d-none");
		}
		$("#track-graph").css("height", 200);
		var ctx = canvas.getContext('2d');
		if (this.chart != null) {
			this.chart.destroy();
		}

		Chart.defaults.LineWithLine = Chart.defaults.line;
		Chart.controllers.LineWithLine = Chart.controllers.line.extend({
			draw: function (ease) {
				Chart.controllers.line.prototype.draw.call(this, ease);

				if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
					var activePoint = this.chart.tooltip._active[0],
						ctx = this.chart.ctx,
						x = activePoint.tooltipPosition().x,
						topY = this.chart.scales['B'].top,
						bottomY = this.chart.scales['B'].bottom;

					self.current_index = activePoint._index;
					self.hover_time = this.chart.chart.data.labels[activePoint._index]._i;
					// draw line
					ctx.save();
					ctx.beginPath();
					ctx.moveTo(x, topY);
					ctx.lineTo(x, bottomY);
					ctx.lineWidth = 1;
					ctx.strokeStyle = '#07C';
					ctx.stroke();
					ctx.restore();

					self.mapHandler.onChartHover(self.step * self.current_index);
				}
			}
		});
		var firstPointDate = _points_[0].date + self.data.utc_offset;
		var lastPointDate = _points_[_points_.length - 1].date + self.data.utc_offset;
		var diffPointsDate = lastPointDate - firstPointDate;

		let displayFormat;
		let diffHours = diffPointsDate / 3600;

		if (diffHours > 4) {
			displayFormat = moment.localeData().longDateFormat('L') + " HH:mm";
		} else if (diffHours > 1) {
			displayFormat = 'HH:mm'; 
		} else {
			displayFormat = 'HH:mm:ss'; 
		}

		Chart.Tooltip.positioners.custom = function (elements, position) {
			if (!elements.length) {
				return false;
			}
			var offset = 0;
			// Adjust offset left or right depending on the event position
			if (elements[0]._chart.width * 0.7 > position.x) {
				offset = 0;
				self.position_tooltip_pointer = "left";
			} else {
				offset = -170;
				self.position_tooltip_pointer = "right";
			}
			return {
				x: position.x + offset,
				y: position.y
			}
		}
		const graphDefinition = this.getCurrentGraphDefinition();
		const speedDatasetDefinition = this.getSpeedDatasetDefinition();

		// Add speed dataset by default, but not for altitude-only view
		const dataSets = [];
		let maxSpeedValue = null;
		if (this.currentGraphType !== 'altitude') {
			const speedDataset = this.getDataSet(speedDatasetDefinition, (x) => (x * 3.6).toFixed(2));
			speedDataset.lineTension = 0.4;

			// Apply moving average smoothing to speed data for a beautiful curve
			const windowSize = 5; // Average over 5 points
			const smoothedData = [];
			for (let i = 0; i < speedDataset.data.length; i++) {
				const start = Math.max(0, i - Math.floor(windowSize / 2));
				const end = Math.min(speedDataset.data.length, i + Math.ceil(windowSize / 2));
				let sum = 0;
				let count = 0;
				for (let j = start; j < end; j++) {
					sum += parseFloat(speedDataset.data[j].y);
					count++;
				}
				smoothedData.push({
					x: speedDataset.data[i].x,
					y: (sum / count).toFixed(2),
					track_point_id: speedDataset.data[i].track_point_id
				});
			}
			speedDataset.data = smoothedData;

			// Calculate max speed value to scale the y-axis
			maxSpeedValue = Math.max(...smoothedData.map(d => parseFloat(d.y)));

			dataSets.push(speedDataset);
		}

		// Calculate optimal min/max for altitude graphs to use full chart height
		if ((this.currentGraphType === 'altitude' || this.currentGraphType === 'altitude-speed') && _points_.length > 0) {
			// Get min/max from both altitude and elevation properties
			let altitudeValues = _points_.map(p => p.altitude).filter(v => v !== null && v !== undefined);
			let elevationValues = _points_.map(p => p.elevation).filter(v => v !== null && v !== undefined);
			let allValues = [...altitudeValues, ...elevationValues];

			if (allValues.length > 0) {
				const dataMin = Math.min(...allValues);
				const dataMax = Math.max(...allValues);

				// Add small padding for better visualization
				const range = dataMax - dataMin;
				const padding = range * 0.22;

				// Set calculated min/max on the first dataset definition (used by y-axis)
				graphDefinition.dataSets[0].min = Math.floor(dataMin - padding);
				graphDefinition.dataSets[0].max = Math.ceil(dataMax + padding);
			}
		}

		// Create gradient for elevation dataset using full canvas height
		const canvasHeight = ctx.canvas.height;
		const elevationGradient = ctx.createLinearGradient(0, 0, 0, canvasHeight);
		elevationGradient.addColorStop(0, 'rgba(111, 107, 107, 1)');    // Red at top
		// elevationGradient.addColorStop(0.5, 'rgba(180, 99, 77, 0.6)');  // Brown in middle
		elevationGradient.addColorStop(1, 'rgb(205, 217, 184)');    // Red light at bottom

		// Add all datasets from the graph definition
		graphDefinition.dataSets.forEach(x => {
			const dataset = this.getDataSet(x);
			// Apply gradient to elevation dataset
			if (x.property === 'elevation') {
				dataset.backgroundColor = elevationGradient;
			}
			dataSets.push(dataset);
		});

		this.chart = new Chart(ctx, {
			type: "LineWithLine",
			data: {
				labels: _points_.map((a, index) => index),
				datasets: dataSets
			},
			// Configuration options go here
			options: {
				layout: {
					padding: {
						left: 15,
						right: 20,
						top: 5,
						bottom: 5
					}
				},
				animation: {
					duration: 3_000,
					easing: 'easeOutQuart' ,
				},
				hover: {
					animationDuration: 100
				},
				events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
				legend: { display: false },
				tooltips: {
					position: 'custom',
					intersect: false,
					enabled: false,
					mode: "index",
					callbacks: {
						label: function (tooltipItem, data) {
							const index = tooltipItem.datasetIndex;
							const dataset = dataSets[index];

							// Map property to MDI icons
							let icon = 'mdi-help-circle'; // default icon

							if (dataset && dataset.property) {
								if (dataset.property === 'speed') {
									icon = 'mdi-speedometer';
								} else if (dataset.property === 'altitude') {
									icon = 'mdi-elevation-rise';
								} else if (dataset.property === 'elevation') {
									icon = 'mdi-terrain';
								} else if (dataset.property === 'heart_rate') {
									icon = 'mdi-heart-pulse';
								} else if (dataset.property === 'cadence') {
									icon = 'mdi-timelapse';
								} else if (dataset.property === 'power') {
									icon = 'mdi-power-plug';
								}
							}

							return `<i class="mdi ${icon}"></i> <span class="fw-600 index_marker"> ${tooltipItem.yLabel}</span><small>${data.datasets[index].measureUnit}</small>`;
						}
					},
					custom: function (tooltipModel) {
						// Tooltip Element
						var tooltipEl = document.getElementById('chartjs-tooltip');

						// Create element on first render
						if (!tooltipEl) {
							tooltipEl = document.createElement('div');
							tooltipEl.id = 'chartjs-tooltip';
							tooltipEl.innerHTML = '<table></table>';
							document.body.appendChild(tooltipEl);
						}

						// Hide if no tooltip
						if (tooltipModel.opacity === 0) {
							tooltipEl.style.opacity = 0;
							return;
						}

						self.tooltip_node = tooltipEl;

						// Set caret Position
						tooltipEl.classList.remove('above', 'below', 'no-transform');
						if (tooltipModel.yAlign) {
							tooltipEl.classList.add(tooltipModel.yAlign);
						} else {
							tooltipEl.classList.add('no-transform');
						}

						function getBody(bodyItem) {
							return bodyItem.lines;
						}

						// Set Text for tooltip
						if (tooltipModel.body) {
							var titleLines = tooltipModel.title || [];
							var bodyLines = tooltipModel.body.map(getBody);

							var innerHtml = '<div id="custom_tooltip" class="' + self.position_tooltip_pointer + '-pointer position-relative py-2 px-2" style="background-color: rgba(40, 43, 52, 0.75); border-radius: 5px; color: white;">';

							bodyLines.forEach(function (body, i) {
								innerHtml += '<div><span class="fs-14">' + body + '</span></div>';
							});

							if (tooltipModel.dataPoints) {
								var dataIndex = tooltipModel.dataPoints[0].index;
								// Get the actual point data to access the date
								if (dataIndex >= 0 && dataIndex < _points_.length) {
									var point = _points_[dataIndex];
									var date = moment.unix(point.date + self.data.utc_offset);
									var timeString = date.format('HH:mm:ss');

									innerHtml += '<div><span class="fs-14"><i class="mdi mdi-clock-outline"></i> <span class="fw-600 index_marker"> ' + timeString + '</span></span></div>';

									// Calculate and display elapsed time since start
									var firstPoint = _points_[0];
									var elapsedSeconds = point.date - firstPoint.date;
									var hours = Math.floor(elapsedSeconds / 3600);
									var minutes = Math.floor((elapsedSeconds % 3600) / 60);
									var seconds = elapsedSeconds % 60;

									var elapsedString = '';
									if (hours > 0) {
										elapsedString = hours + '<small>h</small> ' + minutes + '<small>m</small> ' + seconds + '<small>s</small>';
									} else if (minutes > 0) {
										elapsedString = minutes + '<small>m</small> ' + seconds + '<small>s</small>';
									} else {
										elapsedString = seconds + '<small>s</small>';
									}

									innerHtml += '<div><span class="fs-14"><i class="mdi mdi-timer-sand"></i> <span class="fw-600 index_marker"> ' + elapsedString + '</span></span></div>';
								}
							}

							innerHtml += '</div>';

							var tableRoot = tooltipEl.querySelector('table');
							tableRoot.innerHTML = innerHtml
						}

						// `this` will be the overall tooltip
						var position = this._chart.canvas.getBoundingClientRect();

						// Display, position, and set styles for font
						tooltipEl.style.opacity = 1;
						tooltipEl.style.position = 'absolute';
						tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 10 + 'px';
						tooltipEl.style.top = position.top + window.pageYOffset + 'px';
						tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
						tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
						tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
						tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
						tooltipEl.style.pointerEvents = 'none';
						tooltipEl.style.zIndex = 99999;
					}
				},
				annotation: {
					annotations: [
						{
							drawTime: "afterDatasetsDraw",
							type: "line",
							mode: "vertical",
							scaleID: "x-axis-0",
							value: anotation_value,
							borderWidth: 1,
							borderColor: "red",
						}
					]
				},
				responsive: true,
				maintainAspectRatio: false,
				scales: {
					xAxes: [
						{
							type: 'linear',
							position: 'bottom',
							gridLines: {
								display: false,
								offsetGridLines: false
							},
							ticks: {
								display: true,
								min: 0,
								max: _points_.length - 1,
								padding: -5,
								autoSkip: true,
								maxTicksLimit: 15,
								fontColor: "#282B34",
								callback: function (value, index, values) {
									// Convert index to actual data point
									const pointIndex = Math.round(value);
									if (pointIndex >= 0 && pointIndex < _points_.length) {
										const point = _points_[pointIndex];
										const date = moment.unix(point.date + self.data.utc_offset);

										// Hide first and last labels to prevent overlap
										if (index === 0 || index === values.length - 1) {
											return "";
										}

										// Format as HH:mm (hours:minutes only, no seconds)
										return date.format('HH:mm');
									}
									return "";
								},
							}
						}
					],
					yAxes: [{
						stacked: true,
						id: 'A',
						type: 'linear',
						position: 'left',
						gridLines: {
							color: "#ced4da"
						},
						ticks: {
							beginAtZero: false,
							padding: 10,
							max: graphDefinition.dataSets[0].max,
							min: graphDefinition.dataSets[0].min,
							mirror: false,
							autoSkip: false,
							stepSize: graphDefinition.step,
							callback: function (value, index, values) {
								return value + graphDefinition.dataSets[0].unit;
							},
							fontColor: "#282B34",
						}
					},
					{
						id: 'B',
						type: 'linear',
						position: 'right',
						display: self.currentGraphType !== 'altitude', // Hide right y-axis for altitude-only view
						gridLines: {
							display: false,
						},
						ticks: {
							minor: {
								display: "top"
							},
							major: {
								display: "top"
							},
							padding: 0,
							mirror: false,
							beginAtZero: (!isSubPoint),
							max: maxSpeedValue ? Math.ceil(maxSpeedValue * 2) : undefined,
							stepSize: 20,
							callback: function (value, index, values) {
								return value + speedDatasetDefinition.unit;
							},
							fontColor: "#282B34",
							display: self.currentGraphType !== 'altitude' // Hide ticks for altitude-only view
						}
					}
					]
				}
			},
			plugins: [{
				beforeDraw: function (chart) {
					self.drawYAxisBackground(self, chart, graphDefinition.backgroundRules);
				},
				afterDraw: function (data) {
					self.drawLabels(self,data);
				}
			}],
		});

		// Initialize crop modal if not done
		if (!this.modalInitialized) {
			this.initializeCropModal();
		}
	}

	drawLabels(self,data) {
		const labels = self.chartLabels[self.currentGraphType];
		if (labels && labels.length) {
			var ctx = data.chart.ctx;
			ctx.font = "12px Lato";
			ctx.textAlign = "start";
			ctx.textBaseline = "bottom";
			ctx.fillStyle = "#000000A0"

			labels.forEach(x => {
				ctx.fillText(x.text, 65, x.yPos);
			})
		}
	}

	drawYAxisBackground(self,data, backgroundRules) {
		if (!backgroundRules) {
			return;
		}
		self.chartLabels[self.currentGraphType] = [];
		const labels = self.chartLabels[self.currentGraphType];
		var ctx = data.chart.ctx;

		var rules = backgroundRules;
		var yaxis = data.chart.scales["A"];
		var xaxis = data.chart.scales["x-axis-0"];
		const maxYValue = yaxis.max;
		const minYValue = yaxis.min;
		if (maxYValue <= minYValue) {
			return;
		}

		var color = ctx.createLinearGradient(xaxis.left + (xaxis.width - xaxis.left) / 2, yaxis.top + yaxis.height, xaxis.left + (xaxis.width - xaxis.left) / 2, yaxis.top);


		for (var i = 0; i < rules.length; i++) {
			const rule = rules[i];
			if (i == 0) {
				color.addColorStop(0, rule.backgroundColor);
			}
			let ruleValue = rule.yAxisSegment < minYValue ? minYValue : rule.yAxisSegment;
			ruleValue = ruleValue > maxYValue ? maxYValue : ruleValue;
			const normPoint = (ruleValue - minYValue) / (maxYValue - minYValue);
			color.addColorStop(normPoint, rule.backgroundColor);
			if (i == rules.length - 1) {
				color.addColorStop(1, rule.backgroundColor);
			}
			if (rule.label) {
				labels.push({ text: rule.label, yPos: Math.round(yaxis.top + yaxis.height * (1 - normPoint)) + 5 });
			}

		}
		ctx.fillStyle = color;
		ctx.fillRect(xaxis.left, yaxis.top, xaxis.width, yaxis.height);
	}

	getDataSet(datasetDefinition, mappingFunction) {
		return {
			lineTension: 0,
			steppedLine: datasetDefinition.steppedLine ? datasetDefinition.steppedLine : false,
			hidden: false,
			// type: datasetDefinition.type ? datasetDefinition.type : 'line',
			min: 20,
			max: 30,
			yAxisID: datasetDefinition.yAxis,
			label: datasetDefinition.label,
			property: datasetDefinition.property,
			pointBackgroundColor: datasetDefinition.pointBackgroundColor,
			borderColor: datasetDefinition.borderColor,
			backgroundColor: datasetDefinition.backgroundColor ? datasetDefinition.backgroundColor : 'rgb(245, 246, 247, 0.5)',
			pointRadius: 0,
			borderWidth: datasetDefinition.borderWidth ? datasetDefinition.borderWidth : 1,
			pointHoverRadius: 0,
			data: this.current_points.map((a, index) => ({
				x: index,
				y: mappingFunction ? mappingFunction(a[datasetDefinition.property]) : a[datasetDefinition.property],
				track_point_id: a.track_point_id
			})),
			parsing: {
				xAxisKey: 'x',
				yAxisKey: 'y'
			},
			order: datasetDefinition.order,
			borderDash: datasetDefinition.borderDash ? datasetDefinition.borderDash : false,
			fill: datasetDefinition.fill ? datasetDefinition.fill : false,
			measureUnit: datasetDefinition.unit
		}

	}
	onTick(currentPosition) {
		// Check if chart exists (it won't exist in mobile/application mode)
		if (!this.chart) {
			return;
		}

		var step = this.step;
		if (this.current_points > 1000) {
			step = step * 2;
		}
		if (currentPosition % step === 0) {
			let index = parseInt(currentPosition / step);
			if (index < this.current_points.length) {
				this.chart.options.annotation.annotations[0].value = (this.current_points[index].date + this.data.utc_offset) * 1000;
				this.chart.update();
			}
		}
	}

	onDestroy() {
		this.mapHandler && this.mapHandler.onDestroy();

		$("#clear-graph-selection-btn").unbind("click");
		$(".peak-speed-btn").unbind("click");
		$(".performance-btn").unbind("click");
		$(".split-btn").unbind("click");
		$(".graph_switcher").unbind("click");
	}

	getCurrentGraphDefinition() {
		const graphType = this.currentGraphType;
		return this.graphDefinitions[graphType];
	}
	getSpeedDatasetDefinition() {
		return this.graphDefinitions['speed'].dataSets[0];
	}
	graphDefinitions = {		
		'cadence': {
			step: 25,
			steppedLine: true,
			dataSets: [
				{
					type: 'bar',
					yAxis: 'A',
					steppedLine: 'before',
					label: I18n.t('website.track.chart.cadence'),
					pointBackgroundColor: 'rgb(35, 180, 241)',
					borderColor: 'rgb(50, 50, 64)',
					borderWidth: 1,
					property: 'cadence',
					unit: ''
				}
			],
			backgroundRules: [{
				backgroundColor: '#669999',
				yAxisSegment: 1
			},
			{
				backgroundColor: '#FFAAAA',
				yAxisSegment: 360
			}
			]
		},
		'heart-rate': {
			step: 25,
			dataSets: [
				{
					min: 40,    
					max: 200,
					yAxis: 'A',
					label: I18n.t('website.track.chart.heart-rate'),
					pointBackgroundColor: 'rgb(35, 120, 200)',
					borderColor: 'rgb(135, 120, 200)',
					property: 'heart_rate',
					unit: 'BPM'
				}
			],
			backgroundRules: [{
				backgroundColor: '#9DBFDB',
				yAxisSegment: 80
			},
			{
				backgroundColor: '#99EA99',
				yAxisSegment: 100,
				label: I18n.t('website.track.chart.bearing')
			},
			{
				backgroundColor: '#FFFC99',
				yAxisSegment: 120,
				label: I18n.t('website.track.chart.heart-rate-labels.fat-burn')
			},
			{
				backgroundColor: '#FFDC99',
				yAxisSegment: 140,
				label: I18n.t('website.track.chart.heart-rate-labels.aerobic')
			},
			{
				backgroundColor: '#FFC199',
				yAxisSegment: 160,
				label: I18n.t('website.track.chart.heart-rate-labels.great')
			},
			{
				backgroundColor: '#FE999B',
				yAxisSegment: 190,
				label: I18n.t('website.track.chart.heart-rate-labels.red-line')
			}
			],

		},
		'altitude': {
			step: 300,
			dataSets: [
				{
					yAxis: 'A',
					label: I18n.t('website.track.chart.elevation'),
					pointBackgroundColor: 'rgba(7, 1, 0, 1)',
					borderWidth: 1,
					fill: 'origin',
					borderColor: 'rgba(111, 107, 107, 0.5)',
					backgroundColor : 'rgb(222, 173, 152)',
					property: 'elevation',
					unit: this.getAlternateDistanceUnit(),
					order: 1
				},
				{
					steppedLine: 'before',
					yAxis: 'A',
					label: I18n.t('website.track.chart.altitude'),
					pointBackgroundColor: 'rgb(35, 75, 90)',
					fill: 'origin',
					borderColor: 'rgba(255, 25, 4, 0)',
					backgroundColor : 'rgba(235, 35, 35, 0.25)',
					borderWidth: 0,
					property: 'altitude',
					unit: this.getAlternateDistanceUnit(),
					order: 2
				}
			],
			backgroundRules: [{
				backgroundColor: '#f0fcbb',
				yAxisSegment: 1
			},
			{
				backgroundColor: '#a9d1e2',
				yAxisSegment: 5000
			}
			]
		},
		'altitude-speed': {
			step: 300,
			dataSets: [
				{
					yAxis: 'A',
					label: I18n.t('website.track.chart.elevation'),
					pointBackgroundColor: 'rgba(7, 1, 0, 1)',
					borderWidth: 0,
					fill: 'origin',
					borderColor: 'rgba(111, 107, 107, 0.5)',
					backgroundColor : 'rgb(222, 173, 152)',
					property: 'elevation',
					unit: this.getAlternateDistanceUnit(),
					order: 2
				},
				{
					steppedLine: 'before',
					yAxis: 'A',
					label: I18n.t('website.track.chart.altitude'),
					pointBackgroundColor: 'rgb(35, 75, 90)',
					fill: 'origin',
					borderColor: 'rgba(255, 25, 4, 0)',
					backgroundColor : 'rgba(235, 35, 35, 0.25)',
					borderWidth: 0,
					property: 'altitude',
					unit: this.getAlternateDistanceUnit(),
					order: 3
				}
			],
			backgroundRules: [{
				backgroundColor: '#f0fcbb',
				yAxisSegment: 1
			},
			{
				backgroundColor: '#a9d1e2',
				yAxisSegment: 5000
			}
			]
		},
		'speed': {
			step: 20,
			steppedLine: true,
			dataSets: [
				{
					yAxis: 'B',
					label: I18n.t('website.track.chart.speed'),
					pointBackgroundColor: 'rgb(35, 110, 190)',
					borderWidth: 1,
					fill: false,
					borderColor: 'rgb(35, 110, 190, 1)',
					property: 'speed',
					order: 1,
					unit: this.getSpeedUnit()
				}
			]
		},
	}
}

